import React, { Component } from "react";

export default class ElasticCartAd extends Component {
  render() {
    const { src = "/elasticcartad2.png", alt = "Advertisement" } = this.props;

    return (
      <>
        <style>{`
          .ecad-wrapper {
            display: flex;
            justify-content: center;
            align-items: center;
            height: 100vh; /* full screen height */
            background: #fff; /* optional background */
            position: relative;
          }

          .ecad-img {
            max-width: 90%;
            max-height: 80vh; /* prevent overflow */
            object-fit: contain;
            animation: ecad-bounce 1.6s ease-in-out infinite;
          }

          @keyframes ecad-bounce {
            0%, 100% { transform: translateY(0); }
            50% { transform: translateY(-6px); }
          }

          @media (prefers-reduced-motion: reduce) {
            .ecad-img { animation: none !important; }
          }

          .ecad-close {
            position: absolute;
            top: 12px;
            right: 12px;
            z-index: 2;
            border: 0;
            background: rgba(255,255,255,0.9);
            width: 36px;
            height: 36px;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 20px;
            cursor: pointer;
          }
        `}</style>

        <div className="ecad-wrapper">
          <button
            type="button"
            className="ecad-close"
            aria-label="Close advertisement"
            onClick={() => window.history.back()} // or custom hide logic
          >
            ×
          </button>

          <img src={src} alt={alt} className="ecad-img" loading="lazy" />
        </div>
      </>
    );
  }
}
